import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOrdersByDriverCriteria, getScanBatchReports, setScanBatchStatus } from '../../../actions/ddActions';
import { handleEditOrderModal, showAlertSnackbar } from '../../../reducers/uiSlice';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { DataGrid } from '@material-ui/data-grid';
import { RenderCellExpand } from '../../ComplaintModal/DisplayRecords/RenderCellExpand';
import SearchTableHistory from '../SearchTableHistory';
import DriverTransfer from '../DriverTransfer';
import ScanReportRadioGroup from './ScanReportRadioGroup';
import { Button } from '@material-ui/core';
import FullscreenLoading from '../../Common/FullscreenLoading';
import { getUserPreference } from '../../../utilities/common';
import UniDialog from '../../Common/UniDialog';
import ReturnedPackages from './ReturnedPackages';

const useStyles = makeStyles((theme) => ({
    titleSize: { 
        marginTop: 20, 
        fontSize: '1.4rem' 
    },
    tableRowColor: { 
        background: '#212121'
    },
    titlesFlex: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        overflowX: 'auto',
        marginBottom: 10
    },
    title: {
        whiteSpace: "nowrap"
    },
    tableRowColor: { 
        background: '#212121' 
    },
    tableCellFormat: { 
        fontSize: '1.2rem', 
        textAlign: 'center' 
    },
    tableCellContentFormat: { 
        textAlign: 'center' 
    },
    enableClick: {
        color: theme.palette.primary.main,
        cursor: 'pointer',
        textDecoration: 'underline',
        fontWeight: 'bold'
    },
    slashStyle: {
        color: theme.palette.primary.main,
        fontWeight: 'bold'
    },
    disableClick: {
        color: theme.palette.grey[600],
        fontWeight: 'bold'
    },
    clickType: {
        color: theme.palette.primary.main,
        cursor: 'pointer',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        textDecorationLine: 'underline',
        width: 'fit-content'
    }
}));

function SearchTable(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation('driverDispatch');

    const userPref = getUserPreference();

    const dispatchListDate = useSelector(state => state.ddReducer.dispatchList);
    const dropoffList = useSelector(state => state.ddReducer.dropoffList);
    const dispatchListPeriod = useSelector(state => state.ddReducer.dispatchListPeriod);
    const driverIdSearch = useSelector(state => state.ddReducer.driverId);

    const scanStatusList = [
            t('scanning')
        ,
            t('confirm_review')
        ,
            t('start_deliver')
        ]
    const scanReportRadioGroup = {
        all: {
            text: t('all_records')
        },
        scanned: {
            text: t('complete_scan')
        },
        scanning: {
            text: t('scanning')
        }
    }
    const columnsDispatchVAR = [
        {field: 'id', headerName: t('id'), hide: true, flex: 1},
        {field: 'scan_time', headerName: t('time'), width: 200, headerAlign: 'center', align: 'center', flex: 1},
        {field: 'driver_id', headerName: t('driver_id'), width: 150, headerAlign: 'center', align: 'center', sortable: false, flex: 1, sortable: false},
        {
            field: 'name', 
            headerName: t('name'), 
            width: 200, 
            headerAlign: 'center', 
            align: 'center', 
            sortable: false, 
            renderCell: RenderCellExpand,
            flex: 1
        },
        {
            field: 'unscanned_parcels', 
            headerName: t('unscanned'), 
            width: 150, 
            headerAlign: 'center', 
            align: 'center',
            renderCell: (params) => (
                <div
                    className={params.value === 0 ? classes.disableClick : classes.enableClick}
                    onClick={() => {
                        if(params.value) {
                            transferDriver(params.row.driver_id);
                            handleOrderDetail('UNSCANNED', params.row.scan_batch_id);
                            setUnscannedBatchId(params.row.scan_batch_id);
                            setUnscanBatchStatus(params.row.scan_batch_status);
                        }
                    }}
                >
                    {params.value}    
                </div>
            ),
            flex: 1,
            sortable: false
        },
        {
            field: 'scanned_parcels', 
            headerName: t('scanned'), 
            width: 150, 
            headerAlign: 'center', 
            align: 'center',
            renderCell: (params) => (
                <div
                    className={params.value === 0 ? classes.disableClick : classes.enableClick}
                    onClick={() => {
                        if(params.value) {
                            handleOrderDetail('SCANNED', params.row.scan_batch_id)
                        }
                    }}
                >
                    {params.value}    
                </div>
            ),
            flex: 1,
            sortable: false
        },
        {
            field: 'returned_parcels',
            headerName: t('returned_ought'), 
            width: 150, 
            headerAlign: 'center', 
            align: 'center',
            renderCell: (params) => (
                <div
                    className={(params.value === 0 && params.row.total_return_parcels === 0) ? classes.disableClick : classes.enableClick}
                    onClick={() => {
                        if (params.value || params.row.total_return_parcels) {
                            handleOrderDetail('RETURNED', params.row.scan_batch_id)
                        }
                    }}
                >
                    <span>{params.value}</span>
                    /
                    <span>{params.row.total_return_parcels}</span>
                </div>
            ),
            flex: 1,
            sortable: false
        }
    ];

    const [rows, setRows] = useState([]);
    const [open, setOpen] = useState(false);
    const [driverId, setDriverId] = useState('');
    const [transferId, setTransferId] = useState('');
    const [driverDropoffList, setDriverDropoffList] = useState([]);
    const [dispatchList, setDispatchList] = useState([]);
    const [orderList, setOrderList] = useState([]);
    const [criteria, setCriteria] = useState('UNSCANNED');
    const [radio, setRadio] = useState('all');
    const [columnsDispatch, setColumnsDispatch] = useState(columnsDispatchVAR);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [failureOpen, setFailureOpen] = useState(false);
    const [archiveOpen, setArchiveOpen] = useState(false);
    const [archiveSuccessNum, setArchiveSuccessNum] = useState(0);
    const [archiveFailureList, setArchiveFailureList] = useState([]);
    const [archiveDetainedList, setArchiveDetainedList] = useState([]);
    const [batchIdCurr, setBatchIdCurr] = useState('');
    const [unscannedBatchId, setUnscannedBatchId] = useState('');
    const [unscanBatchStatus, setUnscanBatchStatus] = useState();
    const [confirmSubmit, setConfirmSubmit] = useState({open:false});
    const [batchId, setBatchId] = useState();

    function transferDriver(driver_id, id) {
        setOpen(true);
        setDriverId(driver_id);
        setTransferId(id);
    }
    function handleClose() {
        setOpen(false);
    }
    function createRows(list){
        if(list) {
            if(list.length > 0) {
                return list.map((row, index) => {
                    if(row.dispatch_nos) {
                        row.dispatch_nos = row.dispatch_nos.replaceAll(',', '\n');
                    }
                    return {id: index, ...row}
                })
            }
        }
    }
    function handleOrderDetail(criteria, scanBatchId) {
        let params = {
            criteria: criteria,
            scan_batch_id: scanBatchId
        }
        setCriteria(criteria);

        dispatch(getOrdersByDriverCriteria(params))
        .then((res) => {
            setOrderList(res);
            setBatchId(scanBatchId);
            setOpen(true);
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('fail_detail'), type: 'error'}))
        })
    }

    const handleRadioChange = (e) => {
        setRadio(e.target.value);
    }

    const columnsDropoff = [
        {field: 'id', headerName: t('id'), hide: true},
        {field: 'submit_time', headerName: t('submit_time'), width: 250, headerAlign: 'center', align: 'center'},
        {
            field: 'driver_name', 
            headerName: t('driver_id'), 
            headerAlign: 'center', 
            width: 200,
            align: 'center'
        },
        {field: 'service_point_id', headerName: t('service_point_id'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'service_point_name', headerName: t('service_point_name'), width: 200, headerAlign: 'center', align: 'center'},
        {
            field: 'orders', 
            headerName: t('orders'), 
            headerAlign: 'center', 
            width: 350,
            sortable: false,
            renderCell: (params) => {
                return (
                    <div 
                        style={{cursor: 'pointer'}}
                        onClick={() => {
                            setDriverDropoffList(params.row.orders)
                            transferDriver(params.row.driver_id)
                        }}
                    >
                        {params.row.orders.length}
                    </div>
                );
            },
            align: 'center'
        }
    ];

    const handleDispatchListFilter = (list, type) => {
        if(list?.length > 0) {
            return list.filter((item) => {
                return type === 'scanning' ? 
                item.scan_batch_status === 0 : 
                item.scan_batch_status !== 0;
            })
        } else {
            return [];
        }
    }
        

    const handleStatusAction = (params, driverIdCurr) => {
        let statusParams = '';
        if(params.value === 1) {
            statusParams = 'CONFIRM';
        } else if(params.value === 2) {
            statusParams = 'START';
        } else if(params.value === 9) {
            statusParams = 'ARCHIVE';
        } else if(params.value === 0) {
            if(!confirmSubmit.open) {
                setConfirmSubmit({
                    open: true,
                    params: params
                });
                return; 
            } else {
                statusParams = 'REVIEW';
            }
        }
        let paramsNoDate = {
            warehouse: userPref.userCity,
            driver_id: driverIdCurr
        }
        setLoading(true);
        dispatch(setScanBatchStatus(params.row.scan_batch_id, statusParams))
        .then((res) => {
            if(statusParams === 'START') {
                setLoading(false);

                if (res?.biz_data?.data?.failed?.length > 0 || res?.biz_data?.data?.detained_order_tnos?.length > 0) {
                    setBatchIdCurr(params.row.scan_batch_id);
                    setArchiveSuccessNum(res?.biz_data?.data?.updated);
                    setArchiveFailureList(res?.biz_data?.data?.failed_tnos);
                    setArchiveDetainedList(res?.biz_data?.data?.detained_order_tnos);
                    setArchiveOpen(true);
                } else {
                    dispatch(showAlertSnackbar({message: res.biz_message, type: 'success'}));
                    dispatch(getScanBatchReports(paramsNoDate))
                    .finally(() => {
                        setPage(0);
                    })
                }
            } else {
                dispatch(showAlertSnackbar({message: res.biz_message, type: 'success'}));
                dispatch(getScanBatchReports(paramsNoDate))
                .finally(() => {
                    setConfirmSubmit({open:false});
                    setArchiveOpen(false);
                    setLoading(false);
                    setPage(0);
                })
            }
        })
        .catch((err) => {
            setLoading(false);
            if(statusParams === 'CONFIRM' && err.status === 403) {
                setFailureOpen(true);
                return;
            }
            dispatch(showAlertSnackbar({message: t('api_fail'), type: 'error'}))
        })
    }

    useEffect(() => {
        setDispatchList(dispatchListDate);
    }, [dispatchListDate])

    useEffect(() => {
        if(radio === 'all') {
            setDispatchList(dispatchListPeriod);
        } else {
            setDispatchList(handleDispatchListFilter(dispatchListPeriod, radio));
        }
    }, [dispatchListPeriod, radio])

    useEffect(() => {
        setDriverDropoffList([]);
        setDispatchList([]);
        if(props.type === 'pickup_scan_report') {
            setColumnsDispatch((prev) => [
                ...prev,
                {
                    field: 'scan_batch_status', 
                    headerName: t('common:operation'), 
                    width: 250, 
                    align: 'center',
                    sortable: false,
                    flex: 1,
                    headerAlign: 'center',
                    renderCell: (params) => (
                        <>
                            <Button
                                fullWidth
                                variant='outlined'
                                color={params.value === 2 ? 'primary' : ''}
                                disabled={params.value === 0}
                                onClick={()=>handleStatusAction(params, driverIdSearch)}
                                id={`driverdispatch-scanoperation-button-${params.row.scan_batch_id}`}
                            >
                                {scanStatusList[params.value]}
                            </Button>
                            {
                                params.value === 0 &&
                                <Button
                                    fullWidth
                                    variant='outlined'
                                    color='secondary'
                                    disabled={params.value !== 0}
                                    onClick={()=>handleStatusAction(params, driverIdSearch)}
                                    id={`driverdispatch-scanoperationonbehalf-button-${params.row.scan_batch_id}`}
                                    style={{marginLeft:10}}
                                >
                                    {t('confirm_submit_button')}
                                </Button>
                            }
                        </>
                    )
                }
            ])
        } else {
            setColumnsDispatch(columnsDispatchVAR)
        }
    }, [props.type, driverIdSearch])

    return (
        <>
            <ReturnedPackages
                open={open && criteria === "RETURNED"}
                handleClose={() => setOpen(false)}
                list={orderList}
                batchId={batchId}
            />
            <DriverTransfer 
                open={open && criteria !== "RETURNED"} 
                handleClose={handleClose} 
                rows={rows} 
                driverId={driverId} 
                transferId={transferId} 
                list={props.type==='driver_dropoff'?driverDropoffList:orderList} 
                type={props.type}
                criteria={criteria}
                scanBatchId={unscannedBatchId}
                scanBatchStatus={unscanBatchStatus}
            />
            {
                props.type === 'pickup_scan_report' &&
                <ScanReportRadioGroup 
                    radios={scanReportRadioGroup}
                    radio={radio}
                    handleRadioChange={handleRadioChange}
                />
            }
            {   
                props.type === 'driver_dropoff' &&
                <DataGrid
                    alignItems="center"
                    rows={createRows(dropoffList)||[]}
                    columns={columnsDropoff}
                    disableColumnFilter 
                    disableColumnMenu
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    isRowSelectable={false}
                    style={{height: 600}}
                />
            }
            {   
                (props.type === 'driver_dispatch_new' || props.type === 'pickup_scan_report') &&
                <DataGrid
                    alignItems="center"
                    rows={createRows(dispatchList)||[]}
                    columns={columnsDispatch}
                    disableColumnFilter 
                    disableColumnMenu
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    isRowSelectable={false}
                    style={{height: 600}}
                    page={page}
                    onPageChange={(newPage) => {
                        setPage(newPage);
                    }}
                />
            }
            {   
                props.type === 'driver_dispatch' &&
                <SearchTableHistory type={props.type}/>
            }
            <UniDialog
                open={failureOpen}
                autoClose={false}
                onClose={() => {
                  setFailureOpen(false);
                }}
                onFinish={() => {
                    setFailureOpen(false);
                }}
                title={t('confirm_failure')}
                cancelButtonText={t('common:close')}
                finishButtonText={t('common:ok')}
                maxwidth='sm'
                fullWidth
            >
                <div>{t('clear_unscanned')}</div>    
            </UniDialog>
            <UniDialog
                title={t('partial_success')}
                maxWidth='sm'
                open={archiveOpen}
                fullWidth={true}
                buttons={[
                    {
                        color: 'primary',
                        text: t('ignore'),
                        action: () => {
                            handleStatusAction({
                                row: {
                                    scan_batch_id: batchIdCurr
                                },
                                value: 9
                            }) 
                        },
                        id: 'driverdispatch-searchtable-button-ignore'
                    },
                    {
                        color: 'primary',
                        text: t('common:ok'),
                        action: () => {
                            setArchiveOpen(false);
                            setArchiveFailureList([]);
                            setArchiveDetainedList([]);
                            setArchiveSuccessNum(0);
                        },
                        id: 'driverdispatch-searchtable-button-ok'
                    }
                ]}
            >
                <div>
                    <span>{t('start_success')}</span>
                    <spam>{archiveSuccessNum}</spam>
                </div>
                <div style={{marginTop:20}}>
                    <div>{t('start_failure')}</div>
                    {
                        archiveFailureList?.length > 0 &&
                        archiveFailureList.map((tno, index) => (
                            <div
                                id={`driverdispatch-searchtable-failedorder-button-${index}`}
                                className={classes.clickType}
                                onClick={() => {
                                    dispatch(handleEditOrderModal({open: true, orderIdentifier: tno, type: 'tno'}))
                                }}
                            >
                                {tno}
                            </div>
                        ))
                    }
                </div>
                <div style={{ marginTop: 20 }}>
                    <div>{t('order_detained')}</div>
                    {
                        archiveDetainedList?.length > 0 &&
                        archiveDetainedList.map((tno, index) => (
                            <div
                                id={`driverdispatch-searchtable-detainedorder-button-${index}`}
                                className={classes.clickType}
                                onClick={() => {
                                    dispatch(handleEditOrderModal({ open: true, orderIdentifier: tno, type: 'tno' }))
                                }}
                            >
                                {tno}
                            </div>
                        ))
                    }
                </div>
                <div style={{marginTop:20}}>{t('Please_manage_failure')}</div>
            </UniDialog>
            <UniDialog
                open={confirmSubmit.open}
                autoClose={false}
                onClose={() => {
                  setConfirmSubmit({open:false})
                }}
                title={t('confirm_submit_title')}
                onFinish={() => {
                    handleStatusAction(confirmSubmit.params, driverIdSearch)
                }}
                cancelButtonText={t('common:close')}
                finishButtonText={t('common:confirm')}
                maxwidth='sm'
                fullWidth
            >
                {t('confirm_submit')}
            </UniDialog>
            <FullscreenLoading open={loading}/>
        </>
    );
}
export default SearchTable;